<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
  <div class="row mb-2">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pt-2">
          <div class="text-center text-danger">
            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
              details</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
  <div class="col-12 mb-2">
    <h4 class="mb-0 font-header-1 col-lg-2">Employee</h4>
  </div>
  <div class="col-12 mt-3 ps-0">
    <div widget class="card border-0 box-shadow">
      <div class="card-body">
        <div class="row mt-2 mb-2 d-flex jutify-content-center align-items-center">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="row">
              <div class="col-lg-3 col-md-6 col-sm-12">
                <span>Show employee&nbsp;</span>

                <ng-select class="w-90" [(ngModel)]="EmployeeFilterBo.statusLid" (change)="getEmployeeFilter()"
                  style="color: black;" [clearable]="false" [searchable]="true" [items]="EmployeestatusList"
                  bindLabel="lovName" bindValue="id">
                </ng-select>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12">
                <span>Filter by type &nbsp;</span>
                <ng-select class="w-90" [(ngModel)]="FilteremployeeTypeLid" (change)="getEmployeeFilter()"
                  style="color: black;" [clearable]="false" [searchable]="true" [items]="EmployeeTypeItems"
                  bindLabel="lovName" bindValue="id">
                </ng-select>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12 d-inline-flex mt-4">
                <input type="text" placeholder="Employee name" [(ngModel)]="EmployeeFilterBo.value"
                  (keyup.enter)="getEmployeeFilter()"
                  [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'||global.globalAgencyId==null||global.globalAgencyId==''"
                  class="form-control w-90">
                <i class="bi bi-search fs-5 iconSearch" (click)="getEmployeeFilter()"></i>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12 mt-4">
                <button type="button" class="btn  btn-sm me-3" (click)="editEmployee('new')">Add Employee</button>
                <button type="button" class="btn btn-sm me-3"
                  [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'" (click)="exportCsv()">
                  <i class="fa fa-file-excel-o pe-2"></i>ExportAsCSV</button>
                <button type="button" class="btn btn-sm " (click)="refresh()">Refresh</button>
              </div>
            </div>
          </div>
        </div>
        <!--------------------------------------Ejs Grid------------------------------------------------------------>
        <div class="row mt-4">
          <div class="col-12">
            <ejs-grid #gridEmployee id='grid' [dataSource]='EmployeeGridData | async' [allowResizing]='true'
            [allowSorting]='true' allowPaging='true' [allowFiltering]='true' [pageSettings]='initialPage'
            [filterSettings]='filterSettings' [showColumnChooser]='true' (dataStateChange)='dataChangeEmployee($event)'
            (actionBegin)="onActionEmployee($event)">
            <e-columns>
              <e-column width=100 headerText="Actions" uid="action" textAlign="center" [showInColumnChooser]='false'>
                <ng-template #template let-data>
                  <button class="btn btn-reset-table" data-bs-toggle="modal" ngbTooltip="Reset Password"  *ngIf="fp.employeekeyupdate"
                  data-bs-target="#Reset_ConfirmationEmployee" (click)="resetpassword(data);"                                     
                  ><i
                    class="fa fa-key" aria-hidden="true"></i></button> &nbsp;
                  <button class="btn btn-edit-table" (click)="editEmployee(data)"><i
                      class="fa fa-edit"></i></button>&nbsp;
                </ng-template>
              </e-column>
              <e-column width=140 field="name" headerText="Name" type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column minWidth=100 field="umpi" headerText="UMPI" type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column minWidth=60 field="ssNlast4digits" headerText="SSN (Last 4 Digits)" type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column minWidth=120 field="dob" headerText="DOB" type='date' [format]='formatOptions'></e-column>
              <e-column minWidth=80 field="age" headerText="Age" type='number'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox  mask='000' placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
              </e-column>
              <e-column minWidth=210 field="email" headerText="Email" textAlign='Center' type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column minWidth=100 field="phone1" headerText="Phone" type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column minWidth=100 field="phone2" headerText="phone1" type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column minWidth=100 field="street" headerText="Street" type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column minWidth=100 field="zipcode" headerText="Zip Code" type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column minWidth=100 field="statusLidName" headerText="Status" type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column minWidth=100 field="employeeTypeLidName" headerText="Employee Type" type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
              </e-column>
  
              <e-column minWidth=100 field="locationName" headerText="Location" type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
              </e-column>
  
  
              <!--------------------------------table header icon---------------->
              <e-column minWidth="50" [showInColumnChooser]='false'>
                <ng-template #headerTemplate let-data>
                  <div>
                    <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                  </div>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>


<div class="modal fade " id="Reset_ConfirmationEmployee" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">

  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Reset Password</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        Do you want to reset your password?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" data-bs-dismiss="modal" (click)="changeClientPortalPass()">Yes</button>
        <button type="button" class="btn btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>